import { Button, type ButtonProps } from '@mantine/core';
import { PiX } from 'react-icons/pi';

type Props = ButtonProps & {
  visible: boolean;
  onClick: () => void;
};

export function ClearFiltersButton({ visible, onClick, ...props }: Props) {
  if (!visible) return null;
  return (
    <Button
      variant="subtle"
      size="xs"
      leftSection={<PiX size={12} />}
      onClick={onClick}
      {...props}
    >
      Clear filters
    </Button>
  );
}
